module.exports = __webpack_public_path__ + "static/media/pt-sans-pro_extra-bold.141f7c10.eot";